import React from 'react';
import { Box, Heading, Text, Link } from '@chakra-ui/react';

export const FiveStandLeague = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        This will be a individual league running for 11 weeks. We may also offer 2 man team event for certain leagues each year. Cash prizes will be awarded to individuals and teams. All ties split the cash prize money. A handicap system will make it much more competitive and fun for all levels of shooters and teams.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">How the league works:</Heading>
      <Text mb={4} color="black">
        You shoot two rounds of normal skeet (50 Targets) each week.
      </Text>

      <Text mb={4} color="black">
        1st week is a bank week, these scores will be used if you miss a week. If you miss more than a week, we will allow you to bank or make up targets prior to that week's shooting. A maximum of five banks will be allowed (first night's bank plus four additional) to qualify for payouts.
      </Text>

      <Text mb={4} color="black">
        Minimum top 3 highest averages for the total 10 week program will be paid cash prizes. Depending on size we will also pay Lewis prizes for total combined scores of the whole 10 week program.
        All Ties Split.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">League Costs:</Heading>
      <Text mb={4} color="black">
        One-time payment of $100 ($25 Golden Gun Club fee, $75 for cash prizes) paid separately from targets.
      </Text>

      <Text mb={4} color="black">
        <strong>Payment methods:</strong> Cash, Check, Venmo.
      </Text>

      <Text mb={4} color="black">
        <strong>Target Costs:</strong> Targets are purchased separately from GGC by each shooter based on GGC membership status.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Questions about the league?</Heading>
      <Text mb={4} color="black">
        Email <Link href="mailto:GGCSkeetLeague@gmail.com" color="blue.500">Jason Nester at GGCSkeetLeague@gmail.com</Link>
      </Text>

      <Text mb={4} color="black">
        To sign up find the signup form here and send the correct information via email.
      </Text>
    </Box>
  );
};